var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
export class CardOptions {
}
let Card = class Card extends Vue {
    get mods() {
        let prefix = 'card-component';
        let _modifiers = [];
        if (this.modifiers) {
            this.modifiers.forEach(x => {
                _modifiers.push(`${prefix}--${x}`);
            });
        }
        return _modifiers;
    }
};
Card = __decorate([
    Component({
        props: {
            options: {
                type: Object,
                default: () => new CardOptions()
            },
            modifiers: {
                type: Array,
                default: () => new Array
            }
        }
    })
], Card);
export default Card;
